import { render, staticRenderFns } from "./LibFaq.vue?vue&type=template&id=07cf1507&scoped=true&"
import script from "./LibFaq.vue?vue&type=script&lang=js&"
export * from "./LibFaq.vue?vue&type=script&lang=js&"
import style0 from "./LibFaq.vue?vue&type=style&index=0&id=07cf1507&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cf1507",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/architect/projects/gadzoom/gadzoom-marketing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07cf1507')) {
      api.createRecord('07cf1507', component.options)
    } else {
      api.reload('07cf1507', component.options)
    }
    module.hot.accept("./LibFaq.vue?vue&type=template&id=07cf1507&scoped=true&", function () {
      api.rerender('07cf1507', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/faq/LibFaq.vue"
export default component.exports